// extracted by mini-css-extract-plugin
module.exports = {"list":"_82e3db2ea0--list--um5T6","tablet":"_82e3db2ea0--tablet--A0UgY","phone":"_82e3db2ea0--phone--w1uBL","desktop":"_82e3db2ea0--desktop--EU1Rs"};